import { useEffect, useRef } from 'react';
import { useSetRecoilState } from 'recoil';
import { stepBarPlacementState, StepBarPlacement } from '../state';

/**
 * Syncs the user's persisted step bar placement preference to the Recoil atom
 * on initial load. Runs once when `viewerSettings.stepBarPlacement` is available.
 */
export const useInitStepBarPlacement = (stepBarPlacement: Nullable<string>) => {
  const setStepBarPlacement = useSetRecoilState(stepBarPlacementState);
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (stepBarPlacement && !hasInitialized.current) {
      hasInitialized.current = true;
      const placement = stepBarPlacement === 'top' ? StepBarPlacement.Top : StepBarPlacement.Bottom;
      setStepBarPlacement(placement);
    }
  }, [stepBarPlacement, setStepBarPlacement]);
};
